module.exports = __webpack_public_path__ + "static/pastel-18c338a62dc0784f2dbab609c6f8c4f8.png";